module.exports = __webpack_public_path__ + "static/media/envelope@2x.76322968.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/envelope@2x.png
// module id = 1046
// module chunks = 49